import { render, staticRenderFns } from "./NavbarStart.vue?vue&type=template&id=3dca3472&scoped=true&"
import script from "./NavbarStart.vue?vue&type=script&lang=js&"
export * from "./NavbarStart.vue?vue&type=script&lang=js&"
import style0 from "./NavbarStart.vue?vue&type=style&index=0&id=3dca3472&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca3472",
  null
  
)

export default component.exports